export default __webpack_public_path__ + "static/media/ic_myanmar.dbadb401.svg";